export default __webpack_public_path__ + "static/pragicts-automation-services-monitoring-3f049ab2eeafc5a7cd4d88b4172ae0ef.jpg";